export default "__VITE_ASSET__CXtlGNPW__"